import type { ComponentProps } from 'react'
import { BetaBadge } from '@/src/components/ui/BetaBadge'
import { SHOW_VOICE_ASSESSMENT_BETA_BADGE } from '@/src/config/beta-features'

interface VoiceAssessmentBetaBadgeProps {
  size?: ComponentProps<typeof BetaBadge>['size']
  testID?: string
}

export function VoiceAssessmentBetaBadge({
  size,
  testID,
}: VoiceAssessmentBetaBadgeProps) {
  if (!SHOW_VOICE_ASSESSMENT_BETA_BADGE) {
    return null
  }

  return <BetaBadge size={size} testID={testID} />
}
